<ng-container *ngIf="!isSaving; else loading">
  <div class="dialog-header header">
    <h1 class="header-title">Edit Customer Name</h1>
    <button mat-icon-button aria-label="Close dialog" class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>

  <mat-dialog-content style="padding: 1rem 1.5rem;">
    <form [formGroup]="nameForm" class="form-container">
      <mat-form-field appearance="outline">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstname">
        <mat-error *ngIf="nameForm.get('firstname')?.invalid">
          First Name is required
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Middle Name</mat-label>
        <input matInput formControlName="middlename">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastname">
        <mat-error *ngIf="nameForm.get('lastname')?.invalid">
          Last Name is required
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-divider></mat-divider>

  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="nameForm.invalid" (click)="saveName()">
      Save
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-template #loading>
  <div class="spinner-container">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</ng-template>